import axios from 'axios';
export const getWords = async (page: number, group: number) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}words?page=${page}&group=${group}`)
    .then((response) => {
      return response.data;
    });
};
